/* @flow */
import React from 'react';

import ParamsLink from 'components/Links/ParamsLink';
import Showing from './Showing';

let baseStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1.1rem 1rem 0.5rem',
  backgroundColor: '#fafafa',
  marginTop: 'auto',
};

function rightArrow(style) {
  return (
    <i style={style} className="material-icons">play_arrow</i>
  );
}

function leftArrow(style) {
  return rightArrow({
    transform: 'rotate(180deg)',
    ...style
  });
}

export function calculatePages(props) {
  const { size, total } = props;
  const offset = props.router.location.query.offset ? Number(props.router.location.query.offset) : 0
  const totalPages = Math.ceil(total / size);
  const prev = Math.max(offset - size, 0);
  const last = (totalPages - 1) * size;

  const next = Math.min(offset + size, last);
  const prevPred = offset !== 0;
  const nextPred = offset <= last && (offset + size) < total;
  const currentPage = Math.ceil(offset / size) + 1;

  return {
    offset,
    size,
    prev,
    last,
    next,
    prevPred,
    nextPred,
    currentPage,
    totalPages,
  };
};

export default function Pagination({
  entity,
  ...props
}): React.Element {
  const {
    size = 20,
    prev,
    last,
    next,
    prevPred,
    nextPred,
    currentPage,
    totalPages,
    offset,
  } = calculatePages(props);
  return (
    <div data-testid="pagination-area" style={baseStyles}>
      <div data-testid="text-showing-count" style={{height: '27px'}}>
        <Showing
          entity={entity || 'projects'}
          offset={offset}
          total={props.total}
          size={size}
        />
      </div>
      <div data-testid="pagination-arrows" style={{display: 'flex', alignItems: 'flex-start'}}>

        {prevPred ? (
          <ParamsLink customDataTestID="button-arrow-left-jump-to-end" query={{offset: 0}}>
            {leftArrow()}
            {leftArrow({marginLeft: '-1rem'})}
          </ParamsLink>
        ) : (
          <div>
            {leftArrow({color: '#666'})}
            {leftArrow({marginLeft: '-1rem', color: '#666'})}
          </div>)}
        {prevPred ? (
          <ParamsLink customDataTestID="button-arrow-left-one-page" query={{offset: prev}}>
            {leftArrow()}
          </ParamsLink>
        ) : leftArrow({color: '#666'})}
        <div style={{ margin: '.1rem .25rem'}}>{currentPage}</div>
        {nextPred ? (
          <ParamsLink customDataTestID="button-arrow-right-one-page" query={{offset: next}}>
            {rightArrow()}
          </ParamsLink>
        ) : rightArrow({color: '#666'})}
        {nextPred ? (
          <ParamsLink customDataTestID="button-arrow-right-jump-to-end" query={{offset: last}}>
            {rightArrow({marginRight: '-1rem'})}
            {rightArrow()}
          </ParamsLink>
        ) : (
          <div>
            {rightArrow({marginRight: '-1rem', color: '#666'})}
            {rightArrow({color: '#666'})}
          </div>)}
      </div>
    </div>
  );
}
